var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.441,
    height: 56.441,
    viewBox: "0 0 56.441 56.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-98 -3572.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 56.441,
    height: 56.441,
    rx: 15,
    transform: "translate(98 3572.247)",
    fill: "#59be3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M24.277,2.426C22.655,2.25,20.61,2.25,18,2.25H15.033c-2.608,0-4.653,0-6.275.176A8.27,8.27,0,0,0,4.616,3.81,8.166,8.166,0,0,0,2.81,5.616a6.221,6.221,0,0,0-.594,1.005,10.812,10.812,0,0,0-.855,3.854C1.25,11.969,1.25,13.8,1.25,16.057v.1c0,2.608,0,4.653.176,6.275A8.271,8.271,0,0,0,2.81,26.578a8.165,8.165,0,0,0,1.807,1.807,8.27,8.27,0,0,0,4.142,1.384c1.622.176,3.667.176,6.275.176H18c2.608,0,4.653,0,6.275-.176a8.27,8.27,0,0,0,4.142-1.384,8.164,8.164,0,0,0,1.807-1.807,8.27,8.27,0,0,0,1.384-4.142c.176-1.622.176-3.667.176-6.275v-.106c0-2.273,0-4.113-.113-5.613A10.663,10.663,0,0,0,30.8,6.575a6.2,6.2,0,0,0-.572-.959A8.165,8.165,0,0,0,28.418,3.81a8.271,8.271,0,0,0-4.142-1.384ZM5.868,5.533a6.2,6.2,0,0,1,3.119-.989c1.494-.162,3.423-.163,6.11-.163h2.84c2.686,0,4.616,0,6.11.163a6.2,6.2,0,0,1,3.119.989A6.035,6.035,0,0,1,28.5,6.868L25.807,9.562a64.073,64.073,0,0,1-5.586,5.232,6.022,6.022,0,0,1-3.7,1.557,6.023,6.023,0,0,1-3.7-1.557A64.1,64.1,0,0,1,7.228,9.562L4.534,6.868A6.036,6.036,0,0,1,5.868,5.533Zm23.484,3.5a14.42,14.42,0,0,1,.195,1.575c.107,1.41.107,3.171.107,5.493,0,2.686,0,4.616-.163,6.11a6.2,6.2,0,0,1-.989,3.119,6.033,6.033,0,0,1-1.335,1.335,6.2,6.2,0,0,1-3.119.989c-1.494.162-3.423.163-6.11.163H15.1c-2.686,0-4.616,0-6.11-.163a6.2,6.2,0,0,1-3.119-.989,6.035,6.035,0,0,1-1.335-1.335,6.2,6.2,0,0,1-.989-3.119c-.162-1.494-.163-3.423-.163-6.11,0-2.306,0-4.058.105-5.464a14.5,14.5,0,0,1,.2-1.6l2.1,2.1a64.839,64.839,0,0,0,5.743,5.362,8.1,8.1,0,0,0,5,1.994,8.1,8.1,0,0,0,5-1.994,64.842,64.842,0,0,0,5.743-5.362Z",
    transform: "translate(109.703 3584.371)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFill);
export default __webpack_public_path__ + "static/media/messageFill.8dcce11a6a96a18c6cc2d6a6e2cd5a1c.svg";
export { ForwardRef as ReactComponent };